import { ReactNode } from "react";

import { Stack } from "@mui/material";
import { FormikProps } from "formik";

import { FormikTextField } from "../../../../../../formik/FormikTextField";
import { FormikYesNoAutocomplete } from "../../../../../../formik/FormikYesNoAutocomplete";
import { FieldWithInfo } from "../../../personal-data/components/field-with-info/FieldWithInfo";
import { AssetAnswerField, AssetsFormValues, AssetsMaxLength } from "../../AssetsView.types";

interface Props {
  formik: FormikProps<AssetsFormValues>;
  field: AssetAnswerField;
  label: string;
  detailsField?: AssetAnswerField;
  detailsLabel?: string;
  detailsInfo?: string;
  detailsTrigger?: boolean;
  onValueChange?: (value: boolean | null) => void;
  children?: ReactNode;
}

export function AssetYesNoQuestion({
  formik,
  field,
  label,
  detailsField,
  detailsLabel,
  detailsInfo,
  detailsTrigger = true,
  onValueChange,
  children,
}: Props) {
  const isTriggered = formik.values.answers[field] === detailsTrigger;
  const detailsPath = detailsField ? (`answers.${detailsField}` as const) : null;

  const details = detailsPath && detailsLabel && (
    <FormikTextField
      id={`assets-${detailsField}`}
      formik={formik}
      path={detailsPath}
      label={detailsLabel}
      multiline
      minRows={3}
      slotProps={{ input: { inputProps: { maxLength: AssetsMaxLength.details } } }}
    />
  );

  return (
    <Stack gap={2}>
      <FormikYesNoAutocomplete
        id={`assets-${field}`}
        formik={formik}
        path={`answers.${field}`}
        label={label}
        disableClearable
        onValueChange={onValueChange}
      />
      {isTriggered && (
        <>
          {details &&
            (detailsInfo ? (
              <FieldWithInfo fieldLabel={detailsLabel} info={detailsInfo}>
                {details}
              </FieldWithInfo>
            ) : (
              details
            ))}
          {children}
        </>
      )}
    </Stack>
  );
}
